import { useState } from "react";
import toast from "react-hot-toast";

type useDownloadFileReturnType = [
  (url: string, filename: string, options?: RequestInit) => void,
  boolean,
];

export function useDownloadFile(): useDownloadFileReturnType {
  const [isDownloading, setDownloading] = useState(false);

  const download = (url: string, filename: string, options?: RequestInit) =>
    toast.promise(
      new Promise((resolve, reject) => {
        setDownloading(true);

        return fetch(url, options)
          .then(async (res) => {
            if (res.status !== 200) {
              try {
                const { message } = (await res.json()) as { message: string };
                reject(message);
              } catch {
                reject(res.statusText);
              }
            } else {
              const blob = await res.blob();
              const newBlob = new Blob([blob]);

              const blobUrl = window.URL.createObjectURL(newBlob);

              const link = document.createElement("a");
              link.href = blobUrl;
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
              link.parentNode?.removeChild(link);

              window.URL.revokeObjectURL(blobUrl);

              resolve("Download complete");
            }
          })
          .catch((error) => reject(error.toString()))
          .finally(() => {
            setDownloading(false);
          });
      }),
      {
        loading: `Downloading ${filename}...`,
        success: (message) => String(message),
        error: (error) => error,
      },
    );

  return [download, isDownloading];
}
